import { MediatorAction } from '@shared/types/action.interface';

export namespace InventoryActions {
  export class Update implements MediatorAction {}
}
